<template>
  <div class="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="w-50  space-y-8">
   
      <router-view />
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout'
}
</script>